<template>
    <div class="btn-group">
        <div class="left-div" >
            <input class="styled-checkbox" type="checkbox" v-model="mainCheck">
            <label class="checkboxLabel" @click="handleMainCheck"/>
        </div>
        <button type="button" class="btn btn-default dropdown-toggle" @click="menuVisible = !menuVisible" :disabled="buttonDisabled">
        </button>
        <ul class="dropdown-menu" :style="dropdownShow">
            <li v-for="action in actions" 
            :key="action.name"
            @click="performAction(action.name)" 
            class="dropdown-item">
                <i class="material-icons">
                {{ action.icon }}
                </i>
            </li>
        </ul>
    </div>
</template>
<script>
import alertify from 'alertifyjs';
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'

export default {
    name: 'CheckActions',
    data () {
        return {
            mainCheck: false,
            menuVisible: false,
            checkedItems: [],
            actions: [
                {
                    "icon": "delete",
                    "name": "deleteItems"
                }
            ]
        }
    },
    computed: {
        dropdownShow() {
            return this.menuVisible ? "display:block" : "";
        },
        buttonDisabled() {
            return this.checkedItems.length === 0
        },
        isAdmin() {
            return userService.isAdmin();
        }
    },
    watch: {
        checkedItems(value) {
            if (!value.length) {
                this.menuVisible = false
                this.mainCheck = false
            }
        }
    },
    created: function () {
        this.$eventHub.$on('resetChecked', this.onRefreshContent);
        this.$eventHub.$on('productItemCheck', this.onProductItemCheck);
    },
    destroyed() {
        this.$eventHub.$off('resetChecked');
        this.$eventHub.$off('productItemCheck');
    },
    methods: {
        performAction(action) {
            const that = this
            alertify.confirm('', 'Usunąć zaznaczone produkty?', function(){
                that.deleteProductsFromShop()
                }, function(){},
            );
        },
        deleteProductsFromShop() {
            const req = axios({
                method: 'post',
                url: appConfig.baseUrl + "/productStatuses",
                data: {
                    "storeId": userService.getCurrentStore(),
                    "productIds": this.checkedItems,
                    "status": 4
                },
                headers: {
                    Authorization: userService.getAuthHeader()
                }
            });
            req.then(res => {
                const msg = "Usunięto produkty ";
                alertify.set('notifier','position', 'top-center');
                alertify.success(msg).delay(3);
                this.checkedItems = []
                this.$eventHub.$emit('refreshContent');
            }).catch(_ => {
                console.log("errore deleting ");
            })
        },
        handleMainCheck() {
            this.mainCheck = !this.mainCheck
            if (this.mainCheck) {
                this.$eventHub.$emit('setCheckProduct', true);
            } else {
                this.$eventHub.$emit('setCheckProduct', false);
            }
        },
        updateMainCheck() {
            if (this.checkedItems.length) {
                this.mainCheck = true
            } else {
                this.mainCheck = false
            }
        },
        updateCheckedItems(payload) {
            if (payload.action === "add") {
                this.checkedItems.push(payload.product.id)
            } else {
                var index = this.checkedItems.indexOf(payload.product.id);
                if (index > -1) {
                    this.checkedItems.splice(index, 1);
                }
            }
        },
        handleMainCheckClick() {
            this.mainCheck = !this.mainCheck;
        },
        onProductItemCheck: function(payload) {
            this.updateCheckedItems(payload)
            this.updateMainCheck()
        },
        onRefreshContent: function() {
            this.checkedItems = []
        }

    }
}
</script>
<style scoped lang="scss">

.left-div {
    background:rgb(221, 221, 221);
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.checkboxLabel {
    margin-top: 8px;
    margin-left: 8px;
}

.dropdown-menu {
    min-width: min-content;
    li {
        padding: 0.1rem 1rem;
    }
}

button:active {
    background: #d46464;
}
button:hover {
    border: 1px solid #d46464;
    cursor: pointer;
}

li:hover {
    cursor: pointer;
}

.styled-checkbox {
  position: absolute; // take it out of document flow
  opacity: 0; // hide it

  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
  }

  // Box.
  & + label:before {
    content: '';
    margin-right: 10px;
    display: inline-block;
    vertical-align: text-top;
    width: 15px;
    height: 15px;
    background: white;
  }

  // Box hover
  &:hover + label:before {
    background: #d46464;
  }
  
  // Box focus
  & + label:before {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.12);
  }

  // Box checked
  &:checked + label:before {
    background: #d46464;
  }
  
  // Disabled state label.
  &:disabled + label {
    color: #b8b8b8;
    cursor: auto;
  }

  // Disabled box.
  &:disabled + label:before {
    box-shadow: none;
    background: #ddd;
  }

  // Checkmark. Could be replaced with an image
  &:checked + label:after {
    content: '';
    position: absolute;
    left: 2px;
    top: 9px;
    background: white;
    width: 2px;
    height: 2px;
    box-shadow: 
      2px 0 0 white,
      4px 0 0 white,
      4px -2px 0 white,
      4px -4px 0 white,
      4px -6px 0 white,
      4px -8px 0 white;
    transform: rotate(45deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/utils/CheckActions.vue